import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Hi, I'm Anne Deepa Prasanna🙋🏻‍♀️`}</h2>
    <p>{`I love to transform ideas into beautiful modern web applications.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      